import React from 'react';
import { CopyCard, CopyField, setPageCopySection } from './adminSiteCopyFields';

export default function AdminSiteAboutPageFields({ form, setField }) {
  const about = form.page_copy?.about || {};
  const values = Array.isArray(about.values) ? about.values : [{}, {}, {}];
  const setAbout = (patch) => setPageCopySection(form, setField, 'about', patch);

  const setValue = (index, patch) => {
    const next = [0, 1, 2].map((i) => ({ ...(values[i] || {}), ...(i === index ? patch : {}) }));
    setAbout({ values: next });
  };

  return (
    <>
      <CopyCard title="About page — story block" subtitle="/about main story section">
        <CopyField
          id="about-story-heading"
          label="Story section heading"
          value={about.story_heading || ''}
          onChange={(v) => setAbout({ story_heading: v })}
        />
      </CopyCard>

      <CopyCard title="What we stand for" subtitle="Three value cards on About page">
        <CopyField
          id="about-values-title"
          label="Section title"
          value={about.values_title || ''}
          onChange={(v) => setAbout({ values_title: v })}
        />
        <CopyField
          id="about-values-subtitle"
          label="Section subtitle"
          value={about.values_subtitle || ''}
          onChange={(v) => setAbout({ values_subtitle: v })}
          multiline={2}
        />
        {[0, 1, 2].map((i) => (
          <div key={`about-value-${i}`} className="col-12 border rounded p-3 bg-light">
            <p className="small fw-semibold mb-2">Value card {i + 1}</p>
            <CopyField
              id={`about-value-icon-${i}`}
              label="Icon (emoji)"
              value={values[i]?.icon || ''}
              onChange={(v) => setValue(i, { icon: v })}
            />
            <CopyField
              id={`about-value-title-${i}`}
              label="Title"
              value={values[i]?.title || ''}
              onChange={(v) => setValue(i, { title: v })}
            />
            <CopyField
              id={`about-value-desc-${i}`}
              label="Description"
              value={values[i]?.desc || ''}
              onChange={(v) => setValue(i, { desc: v })}
              multiline={2}
            />
          </div>
        ))}
      </CopyCard>

      <CopyCard title="About page call-to-action" subtitle="Bottom of /about">
        <CopyField
          id="about-cta-lead"
          label="Lead line"
          value={about.cta_lead || ''}
          onChange={(v) => setAbout({ cta_lead: v })}
        />
        <CopyField
          id="about-cta-primary"
          label="Primary button label"
          value={about.cta_primary_label || ''}
          onChange={(v) => setAbout({ cta_primary_label: v })}
        />
        <CopyField
          id="about-cta-secondary"
          label="Secondary button label"
          value={about.cta_secondary_label || ''}
          onChange={(v) => setAbout({ cta_secondary_label: v })}
        />
      </CopyCard>
    </>
  );
}
